var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPretime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55367_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 7.59277H13.3333C13.5101 7.59277 13.6797 7.66301 13.8047 7.78804C13.9298 7.91306 14 8.08263 14 8.25944V8.59277C14 9.59277 12.322 12.3081 11.3333 12.9261V13.5928C11.3333 13.7696 11.2631 13.9392 11.1381 14.0642C11.013 14.1892 10.8435 14.2594 10.6667 14.2594H5.33333C5.15652 14.2594 4.98695 14.1892 4.86193 14.0642C4.7369 13.9392 4.66667 13.7696 4.66667 13.5928V12.9261C3.542 12.2234 2 9.59277 2 8.59277V8.25944C2 8.08263 2.07024 7.91306 2.19526 7.78804C2.32029 7.66301 2.48986 7.59277 2.66667 7.59277Z",
    stroke: "#131313",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99905 2.92676C7.78805 3.0782 7.6171 3.27874 7.50095 3.51104C7.3848 3.74334 7.32694 4.00043 7.33238 4.26009C7.32694 4.51976 7.3848 4.77684 7.50095 5.00914C7.6171 5.24144 7.78805 5.44198 7.99905 5.59342",
    stroke: "#131313",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.667 2.92676C10.456 3.0782 10.2851 3.27874 10.1689 3.51104C10.0528 3.74334 9.99491 4.00043 10.0004 4.26009C9.99491 4.51976 10.0528 4.77684 10.1689 5.00914C10.2851 5.24144 10.456 5.44198 10.667 5.59342",
    stroke: "#131313",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33499 2.92676C5.12399 3.0782 4.95304 3.27874 4.83689 3.51104C4.72073 3.74334 4.66288 4.00043 4.66832 4.26009C4.66288 4.51976 4.72073 4.77684 4.83689 5.00914C4.95304 5.24144 5.12399 5.44198 5.33499 5.59342",
    stroke: "#131313",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55367_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.259766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPretime);
export default __webpack_public_path__ + "static/media/pretime.c98939cf24886f84461b609872e91db6.svg";
export { ForwardRef as ReactComponent };